export default __webpack_public_path__ + "static/media/PlanarImg.239ae295.png";